var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full bg-gray-200  relative overflow-hidden",class:[
    { 'rounded-full': _vm.rounded },
    { indeterminate: _vm.indeterminate },
    _vm.heightClass ]},[_c('div',{staticClass:"h-full progressbar",class:[
      ("bg-" + _vm.color + "-500"),
      { 'absolute top-0': _vm.indeterminate },
      { 'rounded-full': _vm.rounded } ],style:({ width: (_vm.percentage + "%") }),attrs:{"role":"progressbar","aria-valuenow":_vm.percentage,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"flex items-center h-full"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }